import { app } from '../../../../../app';

app.service('ManageSharedAuthenticatorModal', modal);

/** @ngInject */
function modal($uibModal) {
    return account => $uibModal.open({
        component: 'companySharingCenterSharedAuthenticatorsManage',
        resolve: {account: () => account},
    }).result
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.modal.js